<template>
  <div>
    <b-card no-body >
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row>

          <b-col
              xl="6"
              lg="6"
              md="6"
              sm="12"
              class="text-left mb-1"
          >
            <b-button-group>
              <b-button
                  :disabled="loading"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Actualizar datos"
                  variant="gradient-primary"
                  @click="traerShippingAdvice"
              >
                <feather-icon icon="RefreshCwIcon" :class="`${loading ? 'spinner' : ''}`" />
              </b-button>
              <b-button
                  v-if="$can('create', 'Shipping Program')"
                  variant="gradient-primary"
                  v-b-toggle.sidebar-2
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Importar datos"
                  id="imp_dat"
              >
                <feather-icon icon="LogInIcon" />
              </b-button>
              <b-button
                  v-if="$can('read', 'Shipping Program')"
                  @click="descargarFile(false)"
                  variant="gradient-primary"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Exportar datos"
                  id="exp_dat"
                  :disabled="loading_exp"
              >
                <span v-if="loading_exp"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="DownloadIcon" />
              </b-button>
              <b-button
                  v-if="$can('create', 'Shipping Program')"
                  @click="descargarFile(true)"
                  variant="gradient-primary"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Exportar por operador"
                  id="exp_ope"
                  :disabled="loading_exp"
              >
                <span v-if="loading_exp"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="UsersIcon" />
              </b-button>

              <b-button
                  v-if="$can('create', 'Shipping Program')"
                  @click="registrarCambios()"
                  variant="gradient-primary"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Guardar cambios"
                  id="exp_ope"
                  :disabled="loadingSave"
              >
                <span v-if="loadingSave"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="SaveIcon" />
              </b-button>


              <b-button
                  v-if="$can('authorize', 'Shipping Program')"
                  @click="traerPAckStyle()"
                  variant="gradient-info"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Actualizar PackStyle"
                  id="exp_ope"
                  :disabled="loading_packing2"
              >
                <span v-if="loading_packing2"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="LogInIcon" />
              </b-button>
              <b-button
                  v-if="$can('authorize', 'Shipping Program')"
                  @click="packing()"
                  variant="gradient-info"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Exportar Excel - Packing"
                  id="exp_ope"
                  :disabled="loading_packing"
              >
                <span v-if="loading_packing"><b-spinner style="width: 16px; height: 16px;" /></span>
                <feather-icon v-else icon="DownloadIcon" />
              </b-button>

            </b-button-group>
          </b-col>

          <b-col
              xl="6"
              lg="6"
              md="6"
              sm="12"
              class="text-right mb-1 font-medium-1 text-bold font-weight-bold align-self-center"
          >
            Mostrando {{ totalRows === 1 ? "1 registro" : totalRows + " registros" }}.
          </b-col>

          <!--
          <b-col
              xl="4"
              lg="4"
              md="6"
              sm="12"
              class="text-right mb-1"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group>
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                    size="sm"
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      size="sm"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          -->
        </b-row>
      </b-card-body>
      <hot-table
          ref="hotTableComponent"
          :data="items"
          licenseKey='non-commercial-and-evaluation'
      />
    </b-card>
    <b-sidebar
        id="sidebar-2"
        shadow
        bg-variant="white"
        sidebar-class="sidebar-lg"
        backdrop
        no-header
        right
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            Importar Datos
          </h5>

          <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
          />

        </div>

        <b-card-body>
          <b-row>
            <b-col md="12">
              <label>Registro Masivo:</label>
              <b-input-group>
                <b-form-file
                    id="file-small"
                    accept=".xlsx"
                    placeholder="Seleccionar Archivo Excel (.xlsx)"
                    v-model="archivo_excel"
                    ref="fileinput"
                >
                  <template
                      slot="file-name"
                      slot-scope="{ names }"
                  >
                    <b-badge variant="primary">
                      {{ names[0] }}
                    </b-badge>
                  </template>
                </b-form-file>
              </b-input-group>
            </b-col>

            <b-col md="12" class="mt-1">
              <b-button
                  block
                  variant="gradient-primary"
                  :disabled="!archivo_excel || loading"
                  @click="enviarFile"
              >
                <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /> &emsp13; Registrando</span>
                <span v-else>Importar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </template>
    </b-sidebar>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { registerAllEditors } from 'handsontable/editors'
import { esMX, registerLanguageDictionary } from 'handsontable/i18n'

import {
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCardBody,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  BSpinner,
  BTable,
  BSidebar, BFormFile,
  VBTooltip, VBToggle
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

registerAllModules();
registerAllEditors();
registerLanguageDictionary(esMX);

export default {
  components: {
    BBadge,
    BButton,
    BButtonGroup,
    BCard,
    BCardBody,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BSpinner,
    BTable,
    BSidebar,
    BFormFile,
    HotTable
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
  },
  data () {
    return {
      loading: false,
      archivo_excel: null,
      items: [],
      filter: null,
      filterOn: [],
      status: [
        {
          0: 'Activo',
          1: 'Inactivo',
        },
        {
          0: 'light-success',
          1: 'light-danger',
        }
      ],
      changes: [],
      loading_exp: false,
      loading_packing: false,
      loading_packing2: false,
      tabla: null,
      settings: null,
      columnas: {
        'estado': 0,
        'cultivo': 1,
        'cliente': 2,
        'puerto': 3,
        'destino': 4,
        'naviera': 5,
        'nave': 6,
        'etd': 7,
        'eta': 8,
        'fecha_max': 9,
        'fecha_pos': 10,
        'operador': 11,
        'n_inst': 12,
        'n_pbo': 13,
        'n_pv': 14,
        'bk': 15,
        'flete': 16,
        'a_c': 17,
        'observaciones': 18,
        'semana': 19,
        'detalle': 20,
        'variedad': 21,
        'incidencia': 22,
        'campana': 23,
        'id': 24,
        'cantidad': 25
      },
      totalRows: 0,
      arrayEditar: [],
      loadingSave: false,
      columnasOcultadas: [24, 25],
      filtros: [],
    }
  },
  computed: {},
  mounted() {
    const yo = this
    yo.tabla = yo.$refs.hotTableComponent.hotInstance
    yo.settings = {
      width: '100%', //Ancho
      height: '58vh', //Alto
      rowHeaders: true, //Activar numeración de filas
      colHeaders: [
        "ESTADO", //0
        "CULTIVO", //1
        "CLIENTE", //2
        "PUERTO", //3
        "DESTINO", //4
        "NAVIERA", //5
        "NAVE", //6
        "ETD", //7
        "ETA", //8
        "FECHA MAX.", //9
        "FECHA POSIC.", //10
        "OPERADOR", //11
        "N° INST.", //12
        "N° PV", //13
        "N° PBO", //14
        "BK", //15
        "FLETE", //16
        "A/C", //17
        "OBSERVACIONES", //18
        "WK", //19
        "DETALLE", //20
        "VARIEDAD", //21
        "INCIDENCIA", //22
        "CAMPAÑA", //23
        "ID", //24
        "CANTIDAD", //25
      ], //Cabeceras de tabla
      columns: [
        {
          data: 'estado',
          editor: 'select',
          selectOptions: ['NO TRATADO', 'DESPACHADO', 'CANCELADO', 'ELIMINADO', 'DUPLICADO'],
          allowInvalid: false,
          className: "htCenter htMiddle",
          renderer(instance, td, row, col, prop, value, cellProperties) {

            let valor = ''

            valor = value === null ? '' : value

            const spd = valor === 'NO TRATADO' ? 'light-warning' : valor === 'DESPACHADO' ? 'light-success' : valor === 'CANCELADO' ? 'light-danger' : 'light-dark'

            td.className = 'htCenter htMiddle'
            td.innerHTML = '<b-badge class="badge badge-'+ spd +'">'+ valor +'</b-badge>'

            return td
          }
        },
        {
          data: 'cultivo',
          type: 'dropdown',
          className: "htCenter htMiddle",
          allowInvalid: false,
          source: [
            'ARANDANO CONV.',
            'ARANDANO AEREO',
            'ARANDANO CONGELADO',
            'ESPARRAGO',
            'ESPARRAGO AEREO',
            'UVA',
            'PALTA',
            'PALTA TERRESTRE',
            'LIMON'
          ],
        },
        {
          data: 'cliente',
          type: 'dropdown',
          className: "htLeft htMiddle",
          source: []
        },
        {
          data: 'puerto',
          type: 'dropdown',
          className: "htCenter htMiddle",
          source: []
        },
        {
          data: 'destino',
          type: 'dropdown',
          className: "htLeft htMiddle",
          source: []
        },
        {
          data: 'naviera',
          type: 'dropdown',
          className: "htCenter htMiddle",
          source: []
        },
        {
          data: 'nave',
          type: 'dropdown',
          className: "htLeft htMiddle",
          source: []
        },
        {
          data: 'etd',
          editor: 'date',
          dateFormat: 'YYYY-MM-DD',
          renderer(instance, td, row, col, prop, value, cellProperties) {
            const fech = value !== null && value !== '' ? new Date(value.split('-')).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            }) : ""
            td.className = 'htMiddle htCenter'
            td.innerHTML = '<span>'+ fech +'</span>'

            return td
          },
        },
        {
          data: 'eta',
          editor: 'date',
          dateFormat: 'YYYY-MM-DD',
          renderer(instance, td, row, col, prop, value, cellProperties) {
            const fech = value !== null && value !== '' ? new Date(value.split('-')).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            }) : ""
            td.className = 'htMiddle htCenter'
            td.innerHTML = '<span>'+ fech +'</span>'

            return td
          },
        },
        {
          data: 'fecha_max',
          editor: 'date',
          dateFormat: 'YYYY-MM-DD',
          renderer(instance, td, row, col, prop, value, cellProperties) {
            const fech = value !== null && value !== '' ? new Date(value.split('-')).toLocaleString('pe-PE', {
              month: 'long',
              day: '2-digit',
              weekday: 'long',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            }) : ""
            td.className = 'htMiddle htCenter'
            td.innerHTML = '<span>'+ fech +'</span>'

            return td
          },
        },
        {
          data: 'fecha_pos',
          editor: 'date',
          dateFormat: 'YYYY-MM-DD',
          renderer(instance, td, row, col, prop, value, cellProperties) {
            const fech = value !== null && value !== '' ? new Date(value.split('-')).toLocaleString('pe-PE', {
              month: 'long',
              day: '2-digit',
              weekday: 'long',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            }) : ""
            td.className = 'htMiddle htCenter'
            td.innerHTML = '<span>'+ fech +'</span>'

            return td
          },
        },
        {
          data: 'operador',
          type: 'dropdown',
          className: "htLeft htMiddle",
          source: []
        },
        { data: 'n_inst', type: 'text', className: "htCenter htMiddle" },
        { data: 'n_pv', type: 'text', className: "htCenter htMiddle" },
        { data: 'n_pbo', type: 'text', className: "htCenter htMiddle" },
        {
          data: 'bk',
          type: 'text',
          className: "htCenter htMiddle",
          /*
          renderer: (instance, td, row, col, prop, value) => {
            console.log(instance, td, row, col, prop, value)
            const repeatedValues = new Set();

            if (repeatedValues.has(value)) {
              td.style.backgroundColor = '#FFC0CB'; // Color de fondo para valores repetidos
            }
          }
          */
        },
        {
          data: 'flete',
          type: 'dropdown',
          className: "htCenter htMiddle",
          source: ['COLLECT', 'PREPAID']
        },
        {
          data: 'a_c',
          type: 'dropdown',
          className: "htCenter htMiddle",
          source: [ 'SI', 'NO' ]
        },
        { data: 'observaciones', type: 'text', className: "htMiddle" },
        { data: 'semana', type: 'text', className: "htCenter htMiddle" },
        { data: 'detalle', type: 'text', className: "htMiddle" },
        {
          data: 'variedad',
          type: 'dropdown',
          className: "htLeft htMiddle",
          source: [
            'ARRA 15',
            "JACK'S SALUTE",
            'SUGAR CRISP',
            'SWEET GLOBE',
            'SWEET SAPPHIRE',
            'SWETT GLOBE ORGÁNICA'
          ]
        },
        {
          data: 'incidencia',
          type: 'dropdown',
          className: "htLeft htMiddle",
          source: [
            'COMMERCIAL CHANGES',
            "ITINERARY CHANGES",
            'OPERATIONAL PROBLEMS',
            'FRUIT CONDITION',
            'CLIMATE FACTOR',
            'FRUIT VOLUME',
            'STRIKES',
            'COLD TREATMENT FAILED',
          ]
        },
        {
          data: 'campana',
          type: 'dropdown',
          className: "htCenter htMiddle",
          source: [
            '2022',
            "2023",
          ]
        },
        { data: 'id'},
        { data: 'cantidad'},
      ], // Columnas para asignar la data
      hiddenColumns: {},
      language: esMX.languageCode, // Lenguaje español
      locale: "es-MX",
      dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
      filters: true,// Activar Filtro
      contextMenu: {
        items: {
          /*
          customAddRow: {
            name: 'Insertar fila',
            callback: function () {
              const selectedRow = this.getSelected()[0][0]; // Obtener la fila seleccionada
              const rowData = this.getDataAtRow(selectedRow); // Obtener los datos de la fila seleccionada
              // const newRowData = rowData.map((value) => value); // Crear una copia de los datos de la fila seleccionada
              console.log(rowData)

              this.alter('insert_row', selectedRow + 1, 1); // Agregar una fila nueva abajo de la fila seleccionada

              // const rowElement = this.getCell(selectedRow[0] + 1, 0).parentNode;
              // rowElement.classList.add("text-primary");

            },
          },

          "row_above": {
            name: "Insertar fila arriba",
            disabled: function () {
              return false;
            },
            callback: function () {
              this.alter("insert_row", this.getSelected()[0][0]);
            },
            icon: function () {
              var i = document.createElement("i");
              i.className = "fas fa-arrow-up";
              return i;
            }
          },
          "row_below": {
            name: "Insertar fila abajo",
            callback: function () {
              this.alter("insert_row", this.getSelected()[0][0] + 1);
            },
          },
          "remove_row": {
            name: "Eliminar fila",
            callback: function () {
              this.alter('remove_row', this.getSelected()[0][0]);
            }
          },
          */
          row_below: {
            name: 'Agregar fila'
          },
          remove_row: {
            name: 'Eliminar fila'
          },
          /*
          view: {
            name: "Ver información",
            callback: function () {
              const rowData = this.getDataAtRow(this.getSelected()[0][0])
              console.log(rowData)
            },
          },
          */
          hideColumn: {
            name: 'Ocultar columna',
            callback: function(key, selection, event) {
              const selectedColumn = selection[0].start.col
              if(selection[0].start.row !== selection[0].end.row){
                yo.columnasOcultadas.push(selectedColumn)
                this.getPlugin('hiddenColumns').hideColumn(selectedColumn)
                this.render();
              }
            }
          },
          showColumn: {
            name: 'Mostrar columna',
            callback: function(key, selection, event) {
              if(selection[0].start.row !== selection[0].end.row){
                const num = selection[0].start.col
                let col = yo.columnasOcultadas

                if (col.includes(num + 1)) {
                  col = col.filter(function(value) {
                    return value !== num + 1;
                  });
                }

                if (col.includes(num - 1)) {
                  col = col.filter(function(value) {
                    return value !== num - 1;
                  });
                }

                yo.columnasOcultadas = col
                this.getPlugin('hiddenColumns').showColumns([num - 1, num + 1])
                this.render()
              }
            }
          },
        },
      },
      /*
      beforeCopy: function (data, coords) {
        console.log('Evento de copiar:', data, coords);
        // Lógica adicional que deseas ejecutar al capturar el evento de copiar
      },

      */
      afterPaste: this.afterPasteFuncion,
      beforePaste: this.beforePasteFuncion,
      afterChange: this.afterChangeFuncion,
      afterRender: this.afterRenderFuncion,
      afterFilter: this.afterFilterFuncion,
      // cells: this.cellsFuncion,
      columnSorting: true, // Ordenar por columna
      manualColumnResize: true, // Opcion de cambiar tamaño de columna manual
      colWidths: [
        110, // Estado 0
        150, // Cultivo 1
        260, // Cliente 2
        190, // Puerto 3
        140, // Destino 4
        150, // Naviera 5
        220, // Nave 6
        100, // ETD 7
        100, // ETA 8
        180, // Fecha Max. 9
        180, // Fecha Posic. 10
        170, // Operador 11
        130, // N° Inst. 12
        80, // N° PV 13
        80, // N° PBO 14
        108, // BK 15
        80, // Flete 16
        55, // A/C 17
        280, // Observaciones 18
        60, // WK 19
        210, // Detalle 20
        130, // Variedad 21
        160, // Incidencia 22
        100, // Campaña 23
        90, // id 24
        90, // cantidad 25
      ], // Tamaño de columna fijo
      fixedColumnsStart: 1,
      readOnly: false
    }
    this.traerClientes();
    this.traerPolPod();
    this.traerNavieras();
    this.traerNaves();
    this.traerOperadores();
    this.traerShippingAdvice();
  },
  methods: {
    traerShippingAdvice(){
      const yo = this
      yo.loading = true
      yo.tabla.updateData([])

      const config = {
        method: 'get',
        url: '/comex/shippingprogram/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data

              // Modifico los campos si el estado es CANCELADO pongo en blanco campo FECHA POS
              yo.items = response.data.map((item) => {
                if (item.estado === 'CANCELADO') {
                  return {
                    ...item,
                    fecha_pos: '',
                  };
                }
                return item;
              });

              yo.totalRows = response.data.length
              yo.tabla.updateData(response.data)
              yo.settings.hiddenColumns = {
                columns: yo.columnasOcultadas,
                indicators: true
              }
              yo.settings.readOnly = yo.$can('authorize', 'Shipping Program')
              yo.tabla.updateSettings(yo.settings)

              // yo.tabla.getPlugin('filters').addCondition(24, 'by_value', [['2023']])
              // yo.tabla.getPlugin('filters').filter()

              for(const value of yo.filtros){
                yo.tabla.getPlugin('filters').addCondition(value.column, value.conditions[0].name, [value.conditions[0].args[0]])
              }

              yo.tabla.getPlugin('filters').filter()
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
            yo.applyConditionalFormatting();
          })
    },
    traerClientes(){

      const yo = this

      const config = {
        method: 'get',
        url: '/comex/clientes/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.settings.columns[2].source = response.data.data
              yo.tabla.updateSettings(yo.settings)
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          });
    },
    traerPolPod(){

      const yo = this

      const config = {
        method: 'get',
        url: '/comex/pol_pod/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.settings.columns[3].source = response.data.puertos;
              yo.settings.columns[4].source = response.data.destinos;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          });
    },
    traerNavieras(){

      const yo = this

      const config = {
        method: 'get',
        url: '/comex/navieras/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.settings.columns[5].source = response.data.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          });
    },
    traerNaves(){

      const yo = this

      const config = {
        method: 'get',
        url: '/comex/naves/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.settings.columns[6].source = response.data.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          });
    },
    traerOperadores(){

      const yo = this

      const config = {
        method: 'get',
        url: '/comex/operadores/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.settings.columns[11].source = response.data.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){

          });
    },
    descargarFile(opcion){
      const yo = this
      yo.loading_exp = true

      const reSem = this.numeroDeSemana(new Date())
      const dataFiltrada = yo.tabla.getData();

      const headers = [
        'estado',
        'cultivo',
        'cliente',
        'puerto',
        'destino',
        'naviera',
        'nave',
        'etd',
        'eta',
        'fecha_max',
        'fecha_pos',
        'operador',
        'n_inst',
        'n_pv',
        'n_pbo',
        'bk',
        'flete',
        'a_c',
        'observaciones',
        'semana',
        'detalle',
        'variedad',
        'incidencia',
        'campana',
        'id',
        'cantidad'
      ]

      const arrayObjetos = dataFiltrada.map(row => {
        const objeto = {};
        headers.forEach((header, index) => {
          objeto[header] = row[index];
        });
        return objeto;
      });

      if (opcion){
        let operadores = []
        for (const valor of arrayObjetos ){
          operadores.push(valor.operador)
        }

        operadores = [... new Set(operadores)];

        for (const value of operadores){
          const arrayFiltro = arrayObjetos.filter(
              invoice => invoice.operador === value
          )

          const data = JSON.stringify({
            "datas":arrayFiltro,
            "semana": reSem.semana
          })

          const config = {
            method: 'post',
            url: '/comex/shippingprogram/exportar/filter/',
            headers: {
              'Content-Type': 'application/json'
            },
            responseType: 'arraybuffer',
            data : data
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200) {

                  const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                  const fileLink = document.createElement('a');
                  fileLink.href = fileURL;
                  fileLink.setAttribute('download', value === '' || value === null ? "SIN OPERADOR WK. " + reSem.semana + " SHIPPING PROGRAM - " + reSem.fecha + ".xlsx" : value + " WK. " + reSem.semana + " SHIPPING PROGRAM - " + arrayFiltro[0].cultivo + " " + reSem.fecha + ".xlsx");
                  document.body.appendChild(fileLink);
                  fileLink.click();

                  yo.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Archivo creado',
                          icon: 'CheckIcon',
                          text: 'El archivo se creó satisfactoriamente.',
                          variant: 'success',
                        },
                      },
                      {
                        position: 'top-center',
                      })
                }
                else if(response.status === 204){
                  yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'No existen registros',
                      icon: 'AlertTriangleIcon',
                      text: 'No se encontraron registros con los parámetros solicitados.',
                      variant: 'warning',
                    },
                  })
                }
              })
              .catch(function (error) {
                console.log(error);
                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en la creación del archivo',
                    icon: 'XIcon',
                    text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.loading_exp = false
              });

        }
      }
      else{
        const data = JSON.stringify(
            {
              "datas":arrayObjetos,
              "semana": reSem.semana
            }
        )
        const config = {
          method: 'post',
          url: '/comex/shippingprogram/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                let cultivos = []

                for(const valor of arrayObjetos){
                  cultivos.push(valor.cultivo)
                }

                cultivos = [... new Set(cultivos)];

                let nom_cul = ''

                for(const cultivo of cultivos){
                  if(cultivo === 'ARANDANO CONV.') {
                    nom_cul = nom_cul+'BB - '
                  }
                  if(cultivo === 'ARANDANO AEREO') {
                    nom_cul = nom_cul+'AIRBB - '
                  }
                  if(cultivo === 'ARANDANO CONGELADO') {
                    nom_cul = nom_cul+'FBB - '
                  }
                  if(cultivo === 'ESPARRAGO') {
                    nom_cul = nom_cul+'AS - '
                  }
                  if(cultivo === 'ESPARRAGO AEREO') {
                    nom_cul = nom_cul+'AIRAS - '
                  }
                  if(cultivo === 'UVA') {
                    nom_cul = nom_cul+'GR - '
                  }
                  if(cultivo === 'PALTA') {
                    nom_cul = nom_cul+'AVO - '
                  }
                  if(cultivo === 'PALTA TERRESTRE') {
                    nom_cul = nom_cul+'LANDAV - '
                  }
                  if(cultivo === 'LIMON') {
                    nom_cul = nom_cul+'LEMON - '
                  }
                }

                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', nom_cul + "WK. " + reSem.semana + " SHIPPING PROGRAM - " + reSem.fecha + ".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
              else if(response.status === 204){
                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'No existen registros',
                    icon: 'AlertTriangleIcon',
                    text: 'No se encontraron registros con los parámetros solicitados.',
                    variant: 'warning',
                  },
                })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loading_exp = false
            });
      }
    },
    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      //fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      const diasSemana = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', 'DOMINGO']

      let diaDeLaSemana = fecha.getUTCDay();

      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      const dia = ('0' + fecha.getDate()).slice(-2);
      const mes = ('0' + (fecha.getMonth() + 1)).slice(-2);

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        fecha: diasSemana[diaDeLaSemana-1] + " " + dia + "." + mes
      }

    },
    enviarFile(){
      const yo = this
      this.loading = true
      const data = new FormData()
      data.append('file', this.archivo_excel)

      const config = {
        method: 'post',
        url: '/comex/archivo/cargar_sp/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 201){
              yo.traerShippingAdvice()
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Registro guardado',
                  icon: 'CheckIcon',
                  text: 'El envío de los registros se realizó satisfactoriamente.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en el registro',
                icon: 'XIcon',
                text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.archivo_excel = null
            yo.loading = false
          })
      ;

    },
    afterPasteFuncion (data, coords) {
      const yo = this
      const startRow = coords[0].startRow
      const startCol = coords[0].startCol
      const endRow = coords[0].endRow
      const endCol = coords[0].endCol

      for (let row = startRow; row <= endRow; row++) {
        for (let col = startCol; col <= endCol; col++) {

          const existingClasses = yo.tabla.getCellMeta(row, col).className;
          yo.tabla.setCellMeta(row, col, 'className', existingClasses + ' tenue-amarillo');
          // this.setCellMeta(row, col, 'className', 'bg-primary');
        }
      }
      yo.tabla.render();
    },
    beforePasteFuncion (data, coords) {
      // console.log("Before Pasteee")
      /*
      if (coords[0].startCol === 0 && coords[0].endCol === 24){
        // console.log('Evento de pegar:', data, coords);
        for (let i = coords[0].startRow; i <= coords[0].endRow; i++) {
          this.setDataAtCell(i, 0, 'Duplicado')
          this.setDataAtCell(i, 23, 0)
        }
      }
      this.runHooks(this, 'beforePaste', data, coords)
      // Handsontable.hooks.run(originalBeforePaste, hotInstance, data, coords);
      // Lógica adicional que deseas ejecutar al capturar el evento de pegar
      */
    },
    afterChangeFuncion (changes, source) {
      const yo = this
      if (source !== 'loadData') {
        yo.applyConditionalFormatting();
      }

      if (source === 'CopyPaste.paste' && changes.length >= 24) {
        const addedRows = changes.reduce((rows, change) => {
          const row = change[0];
          if (!rows.includes(row)) {
            rows.push(row);
          }
          return rows;
        }, []);

        // console.log(addedRows)
        addedRows.forEach(row => {
          yo.tabla.setDataAtCell(row, 0, 'DUPLICADO');
          yo.tabla.setDataAtCell(row, 24, 0);
        });
      }

      if (source === 'edit') {
        const [fila, columna, antes, despues] = changes[0]
        if(antes !== despues){
          const rowData = yo.tabla.getDataAtRow(fila)
          const existingClasses = yo.tabla.getCellMeta(fila, yo.columnas[columna]).className;
          yo.tabla.setCellMeta(fila, yo.columnas[columna], 'className', existingClasses + ' tenue-amarillo');
          yo.arrayEditar.push({
            id: rowData[24],
            columna: columna,
            cambio: despues,
          })
        }
      }

      yo.tabla.render();
    },
    afterRenderFuncion (isForced){
      // console.log(isForced)
    },
    cellsFuncion (row, column, prop){
      const yo = this
      if(column === 0){

        let valor = ''

        const value = yo.tabla.getDataAtCell(row, column)

        valor = value === null ? '' : value
        //bg-gradient-primary

        const spd = valor === 'NO TRATADO' ? 'bg-warning bg-lighten-3' : valor === 'DESPACHADO' ? 'bg-success bg-lighten-3' : valor === 'CANCELADO' ? 'bg-danger bg-lighten-2 text-white' : (valor === 'ELIMINADO' || valor === 'DUPLICADO') ? 'bg-dark bg-lighten-3 text-white' : 'text-primary'

        // const existingClasses = yo.tabla.getCellMeta(row, column).className;

        yo.tabla.setCellMeta(row, column, 'className', 'font-weight-bold htMiddle '+ spd)

      }
    },
    applyConditionalFormatting () {
      const yo = this
      // const [col] = yo.tabla.getPlugin('nestedHeaders').getHeaderLevels()[0]
      const col = [13, 14, 15, 16]
      let dupRows = new Set()
      const dupCols = new Set()
      const conflicts = {}
      const rows = yo.tabla.countRows()

      for (const indice of col) {
        dupRows = new Set()
        for (let i = 0; i < rows; i++) {
          const value = yo.tabla.getDataAtCell(i, indice)

          if ((value in conflicts) && value != null && value !== '') {
            conflicts[value].push(i)
            dupRows.add(i)
          } else {
            conflicts[value] = [i]
          }
        }
        for (const index of dupRows) {
          yo.tabla.setCellMeta(index, indice, 'className', 'tenue-rojo htCenter htMiddle')
          //yo.tabla.setCellMeta(index, col, 'style', dupStyle)
        }
      }

      yo.tabla.render()
    },
    afterFilterFuncion (conditionsStack) {
      const yo = this
      yo.filtros = conditionsStack

      yo.totalRows = yo.tabla.getData().length
      // yo.tabla.getPlugin('autoColumnSize').recalculateAllColumnsWidth()
    },

    isValueDuplicate (currentRow, currentCol, value) {
      const yo = this
      const columns = [2] // Columnas 3, 4 y 5 (basadas en índices 0)

      for (let row = 0; row < yo.tabla.countRows(); row++) {
        if (row !== currentRow && columns.includes(currentCol)) {
          for (let col of columns) {
            const compareValue = yo.tabla.getDataAtCell(row, col)

            // Verificar si el valor está duplicado en las columnas especificadas
            if (col !== currentCol && compareValue !== null && compareValue !== '' && compareValue === value) {
              return true;
            }
          }
        }
      }

      return false;
    },

    registrarCambios(){
      const yo = this

      const dataFiltrada = yo.tabla.getData();

      const headers = [
        'estado',
        'cultivo',
        'cliente',
        'puerto',
        'destino',
        'naviera',
        'nave',
        'etd',
        'eta',
        'fecha_max',
        'fecha_pos',
        'operador',
        'n_inst',
        'n_pv',
        'n_pbo',
        'bk',
        'flete',
        'a_c',
        'observaciones',
        'semana',
        'detalle',
        'variedad',
        'incidencia',
        'campana',
        'id',
        'cantidad'
      ]

      const arrayObjetos = dataFiltrada.map(row => {
        const objeto = {};
        headers.forEach((header, index) => {
          objeto[header] = row[index];
        });
        return objeto;
      });

      const registrosFiltrados = arrayObjetos.filter(function(objeto) {
        return objeto.id === 0;
      });

      if (registrosFiltrados.length>0 || yo.arrayEditar.length>0){
        yo.loadingSave = true

        const data = JSON.stringify({
          "editar": yo.arrayEditar,
          "crear": registrosFiltrados
        })

        const config = {
          method: 'post',
          url: '/comex/shippingprogram/crear_editar/',
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        }

        axiosIns(config)
            .then(function (response) {
              if(response.status === 200){

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Registros guardados',
                    icon: 'CheckIcon',
                    text: 'El envío de los registros se realizó satisfactoriamente.',
                    variant: 'success',
                  },
                })

                yo.arrayEditar = []

              }
            })
            .catch(function (error) {
              console.log(error);

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en el registro',
                  icon: 'XIcon',
                  text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loadingSave = false
              yo.traerShippingAdvice()
            })

      }
      else{
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: '¡Advertencia!',
            icon: 'CheckIcon',
            text: 'No se encontraron cambios por guardar.',
            variant: 'warning',
          },
        })
      }

    },


    packing(){
      const yo = this
      yo.loading_packing = true

      const reSem = this.numeroDeSemana(new Date())
      const dataFiltrada = yo.tabla.getData();

      const headers = [
        'estado',
        'cultivo',
        'cliente',
        'puerto',
        'destino',
        'naviera',
        'nave',
        'etd',
        'eta',
        'fecha_max',
        'fecha_pos',
        'operador',
        'n_inst',
        'n_pv',
        'n_pbo',
        'bk',
        'flete',
        'a_c',
        'observaciones',
        'semana',
        'detalle',
        'variedad',
        'incidencia',
        'campana',
        'id',
        'cantidad',
      ]

      const arrayObjetos = dataFiltrada.map(row => {
        const objeto = {};
        headers.forEach((header, index) => {
          objeto[header] = row[index];
        });
        return objeto;
      });

      const data = JSON.stringify(
          {
            "datas":arrayObjetos
          }
      )
      const config = {
        method: 'post',
        url: '/comex/shippingprogram/exportar/packing/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "SHIPPING PROGRAM PACKING- " + reSem.fecha + ".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading_packing = false
          });
    },

    packingReload(){
      const yo = this
      yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Registros Actualizados',
              icon: 'CheckIcon',
              text: 'El proceso se ejecutó exitosamente',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })

      yo.traerShippingAdvice()
    },

    traerPAckStyle(){

      const yo = this

      yo.loading_packing2 = true

      const config = {
        method: 'get',
        url: '/comex/shippingprogram/packstyle/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200 && !response.data['is_error']){
              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Registros Actualizados Correctamente',
                      icon: 'CheckIcon',
                      text: "Se actualizaron " + response.data['result'] + "registros.",
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading_packing2 = false
          });
    },


  },
}
</script>

<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style lang="scss">
.tenue-amarillo{
  background-color: rgba(204, 190, 41, 0.4)!important;
  font-weight: 500!important;
}

.tenue-rojo{
  background-color: rgba(204, 114, 41, 0.4) !important;
  font-weight: 500!important;
}
</style>
